export default "__VITE_ASSET__54DkMPfT__"